module.exports = __webpack_public_path__ + "static/media/west-coast-pine-ipa.7113f9b9.webp";